import { jsx as t } from "react/jsx-runtime";
import { b as a } from "../../../create-theme-BiNW1Sh3.js";
import { c as m } from "../../../index-Cu0xwYjD.js";
import '../../../assets/Heading.css';const p = "_heading_164ko_4", v = "_inverted_164ko_9", l = {
  heading: p,
  inverted: v
}, x = {
  h1: "4xl",
  h2: "3xl",
  h3: "2xl",
  h4: "xl"
}, n = ({
  children: e,
  className: c,
  inverted: r,
  level: o = "1",
  semanticComponent: g,
  ...h
}) => {
  const d = o === "1" || o === "2" ? a.font.weight.black : a.font.weight.bold, s = `h${o}`, f = g || s, i = x[s];
  return /* @__PURE__ */ t(
    f,
    {
      className: m(
        l.heading,
        {
          [l.inverted]: r
        },
        c
      ),
      style: {
        fontWeight: d,
        fontSize: `var(--font-size-${i})`,
        lineHeight: `var(--font-line-height-${i})`,
        letterSpacing: `var(--font-letter-spacing-${i})`
      },
      ...h,
      children: e
    }
  );
}, k = ({ ...e }) => /* @__PURE__ */ t(n, { level: "1", ...e }), S = ({ ...e }) => /* @__PURE__ */ t(n, { level: "2", ...e }), $ = ({ ...e }) => /* @__PURE__ */ t(n, { level: "3", ...e }), b = ({ ...e }) => /* @__PURE__ */ t(n, { level: "4", ...e });
export {
  k as Heading1,
  S as Heading2,
  $ as Heading3,
  b as Heading4
};
